export const layoutTooltip = {
  info: "When you connect assets, Triggers help move your users through a flow. Triggers are used to determine which pathways the user will take through the flow.",
  width: 22,
};
